import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id AB365770-45CF-44AC-941E-8E1396FAF428
 * name window-maximize
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/window-maximize.svg
 * tags
 */
export const WindowMaximizeIcon = createSvgIcon(<><path d="M4,4H20V20H4V4M6,8V18H18V8H6Z" /></>, 'WindowMaximizeIcon');
export default WindowMaximizeIcon